"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(_) {
  return {
    root: {
      '&.horizontal': {
        flexDirection: 'row'
      },
      '&.vertical': {
        flexDirection: 'column'
      }
    }
  };
};

exports.default = _default;